export default __webpack_public_path__ + "static/media/folder.a2b719d3.svg";